document.addEventListener('DOMContentLoaded', function () {
  const searchWidgets = document.querySelectorAll('[data-search-popdown]');

  searchWidgets.forEach(function (popdown) {
    const wrapper = popdown.closest('.header__icons-search');
    const toggleBtn = wrapper.querySelector('[data-search-toggle]');
    const input = popdown.querySelector('[data-search-input]');

    const resultsBox = popdown.querySelector('[data-search-results]');

    if (!toggleBtn || !input || !resultsBox) return;

    // 1. Bấm icon -> mở/đóng popdown
    toggleBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      const isOpen = !popdown.hidden;
      popdown.hidden = isOpen;
      toggleBtn.setAttribute('aria-expanded', String(!isOpen));
      if (!isOpen) input.focus();
    });

    
    // 2. Click ra ngoài -> đóng popdown
    document.addEventListener('click', function (e) {
      const clickedToggle = e.target.closest('[data-search-toggle]');
      if (!popdown.hidden && !popdown.contains(e.target) && !clickedToggle) {
        popdown.hidden = true;
        toggleBtn.setAttribute('aria-expanded', 'false');
      }
    });

    // 3. ESC -> đóng popdown
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popdown.hidden) {
        popdown.hidden = true;
        toggleBtn.setAttribute('aria-expanded', 'false');
      }
    });


    // 4. Gõ vào input -> ajax fetch gợi ý
    
    let debounceTimer;
    input.addEventListener('input', function () {

      clearTimeout(debounceTimer);
      const query = input.value.trim();

      if (query.length < 2) {
        resultsBox.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(() => {
        fetch(
          `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`
        )
          .then((res) => res.json())
          .then((data) => renderResults(resultsBox, data.resources.results.products))
          .catch((err) => console.error('Ajax search error:', err));
      }, 300);
    });
    

  });

  function renderResults(resultsBox, products) {
    if (!products || products.length === 0) {
      resultsBox.innerHTML = `<p class="search-popdown__empty">Không tìm thấy kết quả</p>`;
      return;
    }

    resultsBox.innerHTML = products
      .map(
        (p) => `
        <a href="${p.url}" class="search-popdown__item">
          ${p.featured_image ? `<img src="${p.featured_image.url}" width="48" height="48" alt="${p.title}">` : ''}
          <span class="search-popdown__item-title">${p.title}</span>
          <span class="search-popdown__item-price">${p.price}</span>
        </a>
      `
      )
      .join('');
  }
});